module.exports = __webpack_public_path__ + "static/img/landing4.d237d8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/landing4.png
// module id = OdF1
// module chunks = 1